import React from "react"
import { AgilityImage } from "@agility/gatsby-image-agilitycms"
import { renderHTML } from "../../agility/utils"
import { useSiteContext } from "../common/SiteContext"


export interface ILineSeparatorProps {
  className?: string;
}

const LineSeparator = ({ dynamicPageItem }) => {

  const siteContext = useSiteContext();

  return (
    <div className={`${siteContext.listingSeparatorProps?.className}`}/>
  )
}

export default LineSeparator
